import React from "react";

const Nav2 = () => {
  return (
    <div className="bgHome border-bottom border-opacity-25 border-secondary border-3 shadow ">
      <div className="container w-100 ">
        <div className="container py-4 d-flex flex-column flex-md-row justify-content-around align-items-center  fs-5  ">
          <a
            href="#chatboot"
            className="nav-link px-3 py-2  "
            style={{
              backgroundColor: "rgb(224 234 241 / 71%)",
              border: "1px solid #eee",
              borderRadius: "15px",
              color: "rgb(65 105 237)",
              marginBottom:"15px"
            }}
          >
            Chatbot
          </a>
          <a
            style={{
              backgroundColor: "rgb(224 234 241 / 71%) ",
              border: "1px solid #eee",
              borderRadius: "15px",
              color: "rgb(65 105 237)",
              marginBottom:"15px"

            }}
          href="#FeedBack" className="nav-link   px-3 py-2  ">
            FeedBack
          </a>
          <a
            style={{
              backgroundColor: "rgb(224 234 241 / 71%) ",
              border: "1px solid #eee",
              borderRadius: "15px",
              color: "rgb(65 105 237)",
              marginBottom:"15px"

            }}
          href="#test" className="nav-link  px-3 py-2 ">
            Tests
          </a>
          <a
            style={{
              backgroundColor: "rgb(224 234 241 / 71%)",
              border: "1px solid #eee",
              borderRadius: "15px",
              color: "rgb(65 105 237)",
              marginBottom:"15px"

            }}
          href="#articles" className="nav-link  px-3 py-2 ">
            Psychiatric Illness
          </a>
          <a
            style={{
              backgroundColor: "rgba(1rgb(224 234 241 / 71%)",
              border: "1px solid #eee",
              borderRadius: "15px",
              color: "rgb(65 105 237)",
              marginBottom:"15px"

            }}
          href="#SUPPORT" className="nav-link  px-3 py-2 ">
            support Us
          </a>
        </div>
      </div>
    </div>
  );
};

export default Nav2;
